'use strict';

var Ajax = require('./xhr');
var Url = require('./util/url');
var version = require('./constant/version.js').version;
var Logger = require('./util/logger');

var RATE = 0.01;

/**
 * Owl 版本号上报
 * 
 * @param {string} name
 * @param {OWL} Owl
 */
module.exports = function (name, Owl) {
    if (!name || !Owl) return;
    if (Math.random() > RATE) return;

    var ge = function ge(v1, v2) {
        try {
            v1 = v1.split('.').map(function (value) {
                return parseInt(value);
            });
            v2 = v2.split('.').map(function (value) {
                return parseInt(value);
            });
            var ret = void 0;
            if (v1[0] !== v2[0]) {
                ret = v1[0] - v2[0];
            } else if (v1[1] !== v2[1]) {
                ret = v1[1] - v2[1];
            } else {
                ret = v1[2] - v2[2];
            }
            return ret >= 0 ? true : false;
        } catch (e) {
            Logger.ignore(e);
            return false;
        }
    };
    if (ge(Owl.cfgManager.get('version'), version)) return;

    var data = {
        v: 1,
        rate: RATE,
        project: name,
        version: 'v_' + version,
        pageurl: encodeURIComponent(window.location.href),
        count: 1
    };
    var url = Owl.cfgManager.url + '/api/version';
    url = Url.stringify(url, data);
    setTimeout(function () {
        Ajax({
            type: 'GET',
            url: url
        });
    }, 1500);
};